export const TimeOut = 30000;
export const AppInfo = {
    title: "Lệnh điện tử",
};